<template>
  <div>
    <b-container fluid class="pb-4 px-lg-4">
      <template v-if="apiResponse.success">
        <template v-if="items.length">
          <!-- Toolbar -->
          <div class="dir-toolbar">
            <div class="dir-toolbar-search">
              <el-input
                v-model="searchQuery"
                placeholder="Buscar categoría..."
                suffix-icon="el-icon-search"
                size="small"
                clearable
              />
            </div>
            <el-select
              v-model="orderByQuery"
              placeholder="Ordenar"
              size="small"
              class="dir-toolbar-select"
            >
              <el-option label="Recientes" value="recent" />
              <el-option label="Nombre A-Z" value="a-z" />
              <el-option label="Nombre Z-A" value="z-a" />
            </el-select>
            <div class="dir-toolbar-right">
              <ExportButtons
                :data="filteredCategories"
                :columns="exportColumns"
                filename="listado_categorias"
              />
              <button
                class="dir-view-toggle"
                :class="{ active: viewMode === 'grid' }"
                @click="viewMode = 'grid'"
              >
                <i class="el-icon-menu"></i>
              </button>
              <button
                class="dir-view-toggle"
                :class="{ active: viewMode === 'list' }"
                @click="viewMode = 'list'"
              >
                <i class="el-icon-s-unfold"></i>
              </button>
            </div>
          </div>

          <!-- GRID VIEW -->
          <div v-if="viewMode === 'grid'" class="dir-grid">
            <div
              v-for="(item, index) in filteredCategories"
              :key="index"
              class="dir-card"
              @click="goRouter('catalogue.categories.edit', { id: item.id })"
            >
              <div class="dir-card-header">
                <div
                  class="dir-card-avatar"
                  :style="{ background: getColor(index) }"
                >
                  {{ getInitials(item.title) }}
                </div>
                <div style="flex: 1; min-width: 0;">
                  <span class="dir-card-name">{{ item.title }}</span>
                </div>
              </div>
              <div class="dir-card-footer">
                <span class="dir-card-count">
                  <i class="el-icon-goods"></i>
                  {{
                    item.user_business_products
                      ? item.user_business_products.length
                      : 0
                  }}
                  productos
                </span>
              </div>
            </div>
          </div>

          <!-- LIST VIEW -->
          <div v-else class="dir-table">
            <div
              class="dir-table-header"
              style="grid-template-columns: 1fr 120px;"
            >
              <span>Categoría</span>
              <span>Productos</span>
            </div>
            <div
              v-for="(item, index) in filteredCategories"
              :key="'list-' + index"
              class="dir-table-row"
              style="grid-template-columns: 1fr 120px;"
              @click="goRouter('catalogue.categories.edit', { id: item.id })"
            >
              <span class="dir-td-name">
                <div
                  class="dir-row-avatar"
                  :style="{ background: getColor(index) }"
                >
                  {{ getInitials(item.title) }}
                </div>
                <span class="dir-row-name-text">{{ item.title }}</span>
              </span>
              <span style="text-align: center; color: #606266;">
                {{
                  item.user_business_products
                    ? item.user_business_products.length
                    : 0
                }}
              </span>
            </div>
            <div v-if="!filteredCategories.length" class="dir-table-empty">
              Sin resultados
            </div>
          </div>
        </template>
        <EmptyPage
          icon="el-icon-menu"
          text="No tienes categorías registradas."
          v-else
        />
      </template>
      <div v-else class="cat-skeleton">
        <div class="cat-sk-toolbar">
          <div class="cat-sk-bar cat-sk-search"></div>
          <div class="cat-sk-bar cat-sk-select"></div>
          <div class="cat-sk-bar cat-sk-btn"></div>
        </div>
        <div class="cat-sk-grid">
          <div v-for="n in 8" :key="n" class="cat-sk-card">
            <div class="cat-sk-card-header">
              <div class="cat-sk-circle"></div>
              <div class="cat-sk-lines">
                <div class="cat-sk-bar cat-sk-line-title"></div>
                <div class="cat-sk-bar cat-sk-line-sub"></div>
              </div>
            </div>
            <div class="cat-sk-divider"></div>
            <div class="cat-sk-card-footer">
              <div class="cat-sk-bar cat-sk-price"></div>
              <div class="cat-sk-bar cat-sk-badge"></div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import EmptyPage from "../../../components/EmptyPage";
import catalogueService from "../../services/catalogueService";

const COLORS = [
  "#31355c",
  "#3fdbbf",
  "#6366f1",
  "#f59e0b",
  "#ef4444",
  "#8b5cf6",
  "#14b8a6"
];

export default {
  name: "CategoryListComponent",
  data: () => ({
    apiResponse: { success: false },
    searchQuery: "",
    orderByQuery: "recent",
    viewMode: "list",
    items: []
  }),
  computed: {
    filteredCategories() {
      let cats = this.items.concat();
      if (this.searchQuery) {
        const q = this.searchQuery.toLowerCase();
        cats = cats.filter(c => c.title && c.title.toLowerCase().includes(q));
      }
      cats.sort((a, b) => {
        switch (this.orderByQuery) {
          case "recent":
            return (b.id || 0) - (a.id || 0);
          case "old":
            return (a.id || 0) - (b.id || 0);
          case "a-z":
            return (a.title || "")
              .toLowerCase()
              .localeCompare((b.title || "").toLowerCase());
          case "z-a":
            return (b.title || "")
              .toLowerCase()
              .localeCompare((a.title || "").toLowerCase());
          default:
            return 0;
        }
      });
      return cats;
    },
    exportColumns() {
      return [
        { label: "Título", field: "title" },
        {
          label: "Total productos",
          value: i =>
            i.user_business_products ? i.user_business_products.length : 0
        }
      ];
    }
  },
  watch: {
    viewMode(val) {
      this.$store.dispatch("setViewPreference", {
        key: "categories",
        value: val
      });
    }
  },
  methods: {
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    },
    getInitials(name) {
      if (!name) return "?";
      const parts = name.trim().split(/\s+/);
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
      return name.substring(0, 2).toUpperCase();
    },
    getColor(index) {
      return COLORS[index % COLORS.length];
    },
    async handleGetCategories() {
      try {
        let response = await catalogueService.getCategories();
        if (response.data.categories) {
          this.items = response.data.categories;
          this.apiResponse.success = true;
          this.$emit("update-category-count", this.items.length);
        }
      } catch (error) {
        return false;
      }
    }
  },
  components: {
    EmptyPage
  },
  mounted() {
    const saved = this.$store.getters.getViewPreference("categories");
    if (saved) this.viewMode = saved;
    this.handleGetCategories();
  }
};
</script>

<style lang="scss" scoped>
.dir-toolbar .el-input__inner,
.dir-toolbar .el-select .el-input__inner {
  min-height: 34px !important;
  height: 34px;
  font-size: 13px;
  border-radius: 8px;
}

/* ── Catalogue Skeleton ── */
@keyframes cat-shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}
.cat-sk-bar {
  border-radius: 6px;
  background: linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%);
  background-size: 800px 100%;
  animation: cat-shimmer 1.4s infinite linear;
}
.cat-sk-toolbar {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 20px;
}
.cat-sk-search {
  height: 32px;
  flex: 1;
  max-width: 360px;
}
.cat-sk-select {
  height: 32px;
  width: 130px;
}
.cat-sk-btn {
  height: 32px;
  width: 80px;
  margin-left: auto;
}
.cat-sk-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
.cat-sk-card {
  border: 1px solid #e4eaf6;
  border-radius: 12px;
  padding: 16px;
  background: #fff;
}
.cat-sk-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.cat-sk-circle {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  flex-shrink: 0;
  background: linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%);
  background-size: 800px 100%;
  animation: cat-shimmer 1.4s infinite linear;
}
.cat-sk-lines {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.cat-sk-line-title {
  height: 14px;
  width: 70%;
}
.cat-sk-line-sub {
  height: 11px;
  width: 45%;
}
.cat-sk-divider {
  height: 1px;
  background: #e4eaf6;
  margin: 10px 0;
}
.cat-sk-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cat-sk-price {
  height: 16px;
  width: 60px;
}
.cat-sk-badge {
  height: 20px;
  width: 70px;
  border-radius: 10px;
}
@media (max-width: 768px) {
  .cat-sk-grid {
    grid-template-columns: 1fr;
  }
}
</style>
